module.exports = __webpack_public_path__ + "static/img/未标题-777.ac0a9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/未标题-777.png
// module id = 2hzR
// module chunks = 1